import React from 'react';
import { CreditCardIcon, FileTextIcon, LayersIcon, LockIcon, ShieldCheckIcon, SparklesIcon, UsersIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
const badges = [[FileTextIcon, '100% PDF'], [ZapIcon, 'Acceso en 5 min'], [SparklesIcon, 'Principiante → Élite'], [LayersIcon, 'Todos los perfiles'], [UsersIcon, 'Atletas de todas las edades']] as const;
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-176" data-mp="127ec173d7daa">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" data-id="element-177" data-mp="xb5r1d2hkpv7" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-178" data-mp="ncq29gqxlsov">
        <div className="mb-5 inline-flex rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-primary md:mb-6" data-id="element-179" data-mp="nekmstyajisf">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.6rem]" data-id="element-180" data-mp="3j8sezzr63hpb">
          🏋️ Combo Completo Powerlifting Pro 2026
        </h1>
        <p className="mx-auto mt-4 max-w-4xl text-xl font-black leading-tight text-primary md:text-4xl" data-id="element-181" data-mp="39al9qe68qo35">
          Todo tu año de programación de fuerza. Listo. Desde hoy.
        </p>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del Combo Completo Powerlifting Pro 2026" data-id="element-182" data-mp="30i18d5yke5em">
          <img className="w-full max-w-[760px] object-contain drop-shadow-[0_26px_44px_rgba(10,29,56,.28)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Powerlifting Pro 2026 con sus 6 tomos y 6 bonos" data-id="element-183" data-mp="2qk3hsbt8fwiu" />
        </a>

        <p className="mx-auto mt-5 max-w-3xl text-base font-semibold leading-relaxed text-slate-600 md:text-xl" data-id="element-184" data-mp="2ljgyt7f2jrc9">
          <strong className="text-ink" data-id="element-185" data-mp="s3mfk97g6b1j">
            🇦🇷 EL SISTEMA COMPLETO PARA ENTRENADORES DE POWERLIFTING EN ARGENTINA.
          </strong>{' '}
          Principiante → Élite, todos los perfiles. Técnica perfecta + periodización avanzada +
          programas listos para implementar. Sin pasar horas buscando ejercicios. Sin improvisar
          programación. Sin perder tus fines de semana diseñando ciclos.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-186" data-mp="1ayjh1d70le5q">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-187" data-mp="110wovp0pfq3t">
              <BadgeIcon className="h-4 w-4 text-primary" data-id="element-188" data-mp="x031cwr6cdbg" />
              {label}
            </span>)}
        </div>

        <div className="mt-7 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-189" data-mp="3lu9wv02xxwap">
          <span className="flex items-center gap-1" data-id="element-190" data-mp="1x9b4gyotkxbi">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-191" data-mp="1xam4cnf59kxc" />
            Garantía 7 días
          </span>
          <span className="text-primary/30" data-id="element-192" data-mp="21b63fwja2ym4">·</span>
          <span className="flex items-center gap-1" data-id="element-193" data-mp="269hegalb7f5x">
            <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-194" data-mp="268obzltdvbtl" />
            Pago seguro
          </span>
          <span className="text-primary/30" data-id="element-195" data-mp="2b2sn8h9om60h">·</span>
          <span className="flex items-center gap-1" data-id="element-196" data-mp="2g0ls96z90tz6">
            <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-197" data-mp="2g1wyddg62dtg" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-198" data-mp="2p0qn6hn99zwg">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-line bg-white p-4 text-center shadow-sm" data-id="element-199" data-mp="2tyiqe7tcp8fy">
              <p className="text-2xl font-black text-primary md:text-3xl" data-id="element-200" data-mp="uou359r57wbf">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-201" data-mp="zlstdh7orj4c">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}